export const CGET_ORDERS_SUCCESS = '@cGetOrders/success';
export const PUT_ORDER_SUCCESS = '@putOrder/success';
export const DELETE_ORDER_SUCCESS = '@deleteOrder/success';